<template>
  <div class="p-10 pt-5 emptyCat">
    <div
      class="
        flex flex-col
        items-center
        text-center
        bg-white
        mx-auto
        p-10
        empty-module-wrapper
      "
    >
      <div>
        <img src="../../../assets/images/icons/empty-module.jpg" alt="" />
      </div>
      <div class="text-base font-bold mt-8 mb-2">
        Start by adding a
        {{
          this.allowed
            .join(' or ')
            .replace('subcategory', 'chapter')
            .replace('category', 'module')
            .replace('post', 'lesson')
        }}
      </div>
      <gd-button
        v-if="this.allowed.includes('post')"
        class="
          h-10
          btn-width
          px-4
          btn-radius
          text-base
          font-semibold
          mt-10
          mb-5
        "
        size="auto"
        primary
        @click="triggerAddNewHirearchyItem('post')"
        >+ Lesson</gd-button
      >
      <div
        v-if="this.allowed.includes('subcategory')"
        class="text-sm text-pink font-semibold cursor-pointer mb-2"
        @click="triggerAddNewHirearchyItem('subcategory')"
      >
        + Chapter
      </div>
      <div
        v-if="this.allowed.includes('category')"
        class="text-sm text-pink font-semibold cursor-pointer mb-2"
        @click="triggerAddNewHirearchyItem('category')"
      >
        + Module
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'EmptySubCat',
  props: {
    allowed: {},
    triggerAddNewHirearchyItem: {
      type: Function,
      required: true,
    },
  },
};
</script>
<style lang="scss" scoped>
.empty-module-wrapper {
  max-width: 400px;
  box-shadow: 20px 20px 40px rgba(22, 29, 37, 0.05);
  border-radius: 6px;
}
</style>